// extracted by mini-css-extract-plugin
export default {"image":"LyricsPanel_image__Gz88N"};